import { GeneralPermissionCode } from "@odata/GeneratedEnums";
import React from "react";
import { RouteProps } from "react-router";
import { Switch } from "react-router-dom";

import AuditTrailView from "../components/auditTrail/AuditTrailView";
import { WithPermissionContext, withPermissionContext } from "../contexts/permissionContext/withPermissionContext";
import { AUDIT_TRAIL } from "../routes";
import { NoPermission } from "../views/notFound";
import { IFormSwitchProps } from "./FormRoute";
import PrivateRoute from "./PrivateRoute";

class FormDynamicEntityRoute extends React.PureComponent<RouteProps & WithPermissionContext & Pick<IFormSwitchProps, "page" | "GPs" | "CPs">> {
    render() {
        const Form = this.props.page;

        return (
            <Switch>
                <PrivateRoute exact path={`${this.props.path}`}
                              CPs={this.props.CPs}
                              GPs={this.props.GPs}
                              render={() => {
                                  return (
                                      <Form/>
                                  );
                              }}/>
                <PrivateRoute exact path={`${this.props.path}/:ParentId/:Id`}
                              CPs={this.props.CPs}
                              GPs={this.props.GPs}
                              render={() => {
                                  return (
                                          <Form/>
                                  );
                              }}/>
                <PrivateRoute path={`${this.props.path}/:ParentId/:Id/${AUDIT_TRAIL}`}
                              CPs={this.props.CPs}
                              GPs={this.props.GPs}
                              render={() => {
                                  const hasAuditTrailPermission = this.props.permissionContext.generalPermissions.has(GeneralPermissionCode.AuditTrail);
                                  if (!hasAuditTrailPermission) {
                                      return <NoPermission/>;
                                  }
                                  return (
                                          <AuditTrailView/>
                                  );
                              }}/>

            </Switch>
        );
    }
}

export default withPermissionContext(FormDynamicEntityRoute);